export default {
  P1: "#007bff",
  P2: "#3A3A3A",
  S1: "#3B82F6",
  S2: "#FEF4E8",
  BG1: "#2D2D2D",
  BG2: "#3E3B3B",
  BG3: "#4C4C4C",
  G1: "#FFFFFF",
  G2: "#8F8F8F",
  G3: "#636363",
  G4: "#3B3B3B",
  G5: "#E9E9E9",
  gradientStart: "#2D2D2D",
  gradientEnd: "#3E3B3B",
};
